"use client";

import { CircularProgress, InputOtp, Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import ModalLayout from "../ModalLayout";
import { useGlobalData } from "@/contexts/GlobalData";
import DynamicFontSize from "../DynamicFontSize";
import enableDeviceService from "@/services/enableDeviceService";
import { useAuth } from "@/contexts/Auth";
import ConfirmOTPValidate from "../ConfirmOTPValidate";
import { OTP_TYPE } from "@/common/const";
import { ButtonStatus } from "../PrimaryButton";
import comfirmOTPValidateService from "@/services/comfirmOTPValidateService";
function LoginDigitalOTP() {
  const prefix = "login_dotp_";
  const {
    isOpen: isOpenWithdrawDOTP,
    onOpen: onOpenWithdrawDOTP,
    onOpenChange: onOpenChangeWithdrawDOTP,
    onClose: onCloseWithdrawDOTP
  } = useDisclosure();
  const [confirmStatus, setConfirmStatus] = useState<ButtonStatus>("normal");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    translate,
    currentDevice,
    deviceInfo,
    setCurrentDevice
  } = useGlobalData();
  const {
    token
  } = useAuth();
  const handleLoginDigitalOTP = (otp?: string) => {
    setConfirmStatus("loading");
    if (!otp) return;
    try {
      comfirmOTPValidateService(token, otp, OTP_TYPE.OTP_ACTIVE_DEVICE, undefined, res => {
        if (res.success) {
          setCurrentDevice({
            ...currentDevice,
            status: "active"
          });
          setConfirmStatus("success");
          setTimeout(() => {
            setConfirmStatus("normal");
          }, 2000);
          onCloseWithdrawDOTP();
        } else {
          setErrorMessage(res.message);
        }
        setConfirmStatus("error");
        setTimeout(() => {
          setConfirmStatus("normal");
        }, 2000);
      }, undefined, deviceInfo.hash);
    } catch (error) {}
  };
  useEffect(() => {
    if (!currentDevice) return;
    if (currentDevice?.status == "inactive" && currentDevice?.isSetup) {
      onOpenWithdrawDOTP();
    }
  }, [currentDevice]);
  if (isOpenWithdrawDOTP) return <ConfirmOTPValidate claimType={OTP_TYPE.OTP_ACTIVE_DEVICE} claimStatus={confirmStatus} handleClaim={handleLoginDigitalOTP} errorMessage={errorMessage} setErrorMessage={setErrorMessage} onClose={onCloseWithdrawDOTP} prefix={prefix} />;
  return null;
  // return (
  //     <Modal
  //         isOpen={isOpenWithdrawDOTP}
  //         placement="bottom"
  //         onOpenChange={onOpenChangeWithdrawDOTP}
  //         isDismissable={false}
  //         hideCloseButton
  //         closeButton={false}
  //         backdrop="blur"
  //     >
  //         <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
  //             <ModalLayout modalKey="de913d61-77f9-4063-b940-43fe958350a856432" title={translate(prefix + "app")}>
  //                 <div className="py-4 h-full flex flex-col items-center justify-center relative">
  //                     <div className="flex flex-col gap-3 w-full relative">
  //                         {loading && (
  //                             <div className=" absolute top-1/2 -translate-x-1/2 left-1/2  z-[9999] flex items-center justify-center ">
  //                                 <CircularProgress
  //                                     aria-label="Loading..."
  //                                     color="secondary"
  //                                     classNames={{
  //                                         svg: "w-6 h-6",
  //                                     }}
  //                                 />
  //                             </div>
  //                         )}
  //                         {/* <label htmlFor="pin_code">
  //                             <DynamicFontSize fontSize={16} className="font-medium text-white">
  //                                 {translate("please enter 6 digit pin")}
  //                             </DynamicFontSize>
  //                         </label>
  //                         <InputOtp
  //                             id="pin_code"
  //                             type="password"
  //                             name="pin_code"
  //                             autoFocus
  //                             length={6}
  //                             variant="bordered"
  //                             className="w-full text-white"
  //                             size={undefined}
  //                             isDisabled={loading}
  //                             classNames={{
  //                                 input: "text-white ",
  //                                 segmentWrapper: "w-full justify-between",
  //                                 segment:
  //                                     "!bg-white/[0.16] !text-white border-red !size-12 data-[focus=true]:outline-node data-[focus=true]:!size-12 data-[focus=true]:scale-100 rounded-2xl data-[focus=true]:!border data-[focus:true]:!border-description border !border-description",
  //                                 caret: "bg-white",
  //                                 passwordChar: "bg-white",
  //                             }}
  //                             radius={undefined}
  //                             onComplete={handleLoginDigitalOTP}
  //                             errorMessage={errorMessage}
  //                             isInvalid={!!errorMessage}
  //                         /> */}
  //                         <ConfirmOTPValidate
  //                             claimType={OTP_TYPE.OTP_ACTIVE_DEVICE}
  //                             claimStatus={confirmStatus}
  //                             handleClaim={handleLoginDigitalOTP}
  //                             errorMessage={errorMessage}
  //                             setErrorMessage={setErrorMessage}
  //                         />
  //                     </div>
  //                 </div>
  //             </ModalLayout>
  //         </ModalContent>
  //     </Modal>
  // );
}
export default LoginDigitalOTP;